@charset "UTF-8";
/* ==========================================================================
   Design System
   Advanced Typography
   ========================================================================== */
/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.m-pull-quote__body {
  color: var(--black);
  font-size: 1.375em;
  font-weight: normal;
  letter-spacing: inherit;
  line-height: 1.25;
  text-transform: inherit;
}
@media only all and (max-width: 37.5em) {
  .m-pull-quote__body {
    font-size: 1.125em;
    font-weight: normal;
    letter-spacing: inherit;
    line-height: 1.25;
    text-transform: inherit;
  }
}
.m-pull-quote__citation {
  color: var(--gray);
  font-size: 0.875em;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 1.25;
  text-transform: uppercase;
  margin-bottom: 1.0714285714em;
}
p + .m-pull-quote__citation, ul + .m-pull-quote__citation, ol + .m-pull-quote__citation, dl + .m-pull-quote__citation, figure + .m-pull-quote__citation, img + .m-pull-quote__citation, table + .m-pull-quote__citation, blockquote + .m-pull-quote__citation, h1 + .m-pull-quote__citation, .h1 + .m-pull-quote__citation, h2 + .m-pull-quote__citation, .h2 + .m-pull-quote__citation, h3 + .m-pull-quote__citation, .h3 + .m-pull-quote__citation, h4 + .m-pull-quote__citation, .h4 + .m-pull-quote__citation, h6 + .m-pull-quote__citation, .h6 + .m-pull-quote__citation {
  margin-top: 2.1428571429em;
}
.m-pull-quote__citation::before {
  content: "—";
}